export enum FieldSize {
  S = 's',
  M = 'm',
  L = 'l',
  XL = 'xl',
}
